import createActions from 'utils/redux/createActions'

export default createActions([
	'SET_PERIOD'
  , 'SET_PROPERTY'
  , 'SET_REPORT_TYPE'
  , 'TEMPLATE_GOT'
  , 'SET_PERFOMANCE_PERIOD'
])



// WEBPACK FOOTER //
// ./src/actions/financeActions.js